import { render, staticRenderFns } from "./AskType.vue?vue&type=template&id=bcd307b4&"
import script from "./AskType.vue?vue&type=script&lang=js&"
export * from "./AskType.vue?vue&type=script&lang=js&"
import style0 from "./AskType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports